import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ForgeGlobalPageExtensionPoint } from '@confluence/forge-ui/entry-points/GlobalPage.ts';

export const GlobalPageForgeAppsRoute: {
	({ params: { appId, envId, forgeManifestRoute } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { appId, envId, forgeManifestRoute } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					appId: string;
					envId: string;
					forgeManifestRoute: string;
				};
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({ params: { appId, envId, forgeManifestRoute } }: RouteMatch): React.JSX.Element => (
	<ForgeGlobalPageExtensionPoint
		key={`${appId}-${envId}-${forgeManifestRoute}`}
		appId={appId}
		envId={envId}
		forgeManifestRoute={forgeManifestRoute}
	/>
);

GlobalPageForgeAppsRoute.NAVIGATION_PARAMS = ({
	params: { appId, envId, forgeManifestRoute },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				appId: string;
				envId: string;
				forgeManifestRoute: string;
			};
		};
	};
	MainLayout: {
		navView: string;
	};
} => {
	return {
		Screen: {
			screenEvent: {
				name: 'globalPageScreen',
				id: appId,
				attributes: { appId, envId, forgeManifestRoute },
			},
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
		},
	};
};
